// extracted by mini-css-extract-plugin
export default {"content":"index_content_6U-Co clearfix"};